module.exports = "pegasus_template/assets/hexagon-facebook.gif";